import DeprecatedFilter from 'customer-data-filters-ui/filterQueryFormat/operator/DeprecatedFilter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConstantFilterWarning = props => {
  const {
    condition
  } = props;
  const shouldRenderWarning = condition && condition.constructor === DeprecatedFilter;
  if (!shouldRenderWarning) {
    return null;
  }
  const includeAll = condition.value;
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "100",
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: includeAll ? 'newCustomerDataFilters.deprecatedFilter.descriptionIncludeAll' : 'newCustomerDataFilters.deprecatedFilter.descriptionExcludeAll'
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        title: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: includeAll ? 'newCustomerDataFilters.deprecatedFilter.infoIconDescriptionIncludeAll' : 'newCustomerDataFilters.deprecatedFilter.infoIconDescriptionExcludeAll'
          })
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(InfoIcon, {
          color: "icon-core-subtle",
          size: "200"
        })
      })]
    })
  });
};
export default ConstantFilterWarning;